import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSubItems$1 = /*@__PURE__*/ proxyCustomElement(class WppIconSubItems extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-sub-items", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.39941 2.65002C4.39941 2.23581 4.06363 1.90002 3.64941 1.90002C3.2352 1.90002 2.89941 2.23581 2.89941 2.65002V12.9536C2.89941 14.4724 4.13063 15.7036 5.64941 15.7036H10.9905C11.3261 17.0573 12.5491 18.0608 14.0066 18.0608C15.7226 18.0608 17.1137 16.6696 17.1137 14.9536C17.1137 13.2376 15.7226 11.8465 14.0066 11.8465C12.5491 11.8465 11.3261 12.8499 10.9905 14.2036H5.64941C4.95906 14.2036 4.39941 13.644 4.39941 12.9536V8.40716H10.9905C11.3261 9.76086 12.5491 10.7643 14.0066 10.7643C15.7226 10.7643 17.1137 9.37319 17.1137 7.65716C17.1137 5.94113 15.7226 4.55002 14.0066 4.55002C12.5491 4.55002 11.3261 5.55346 10.9905 6.90716H4.39941V2.65002ZM12.3994 14.9536C12.3994 14.066 13.119 13.3465 14.0066 13.3465C14.8942 13.3465 15.6137 14.066 15.6137 14.9536C15.6137 15.8412 14.8942 16.5608 14.0066 16.5608C13.119 16.5608 12.3994 15.8412 12.3994 14.9536ZM12.3994 7.65716C12.3994 6.76956 13.119 6.05002 14.0066 6.05002C14.8942 6.05002 15.6137 6.76956 15.6137 7.65716C15.6137 8.54476 14.8942 9.2643 14.0066 9.2643C13.119 9.2643 12.3994 8.54476 12.3994 7.65716Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-sub-items-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-sub-items", "wpp-icon-sub-items-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-sub-items-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-sub-items-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSubItems$1);
      }
      break;
  } });
}

const WppIconSubItems = WppIconSubItems$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconSubItems, defineCustomElement };
